import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sharedActions from '../../Actions/sharedActions';
import SnackBar from '../../components/SnackBar/SnackBar';
import { Link } from 'react-router-dom';
import DatePicker from 'react-date-picker';
import months from '../../utils/general';
import CustomFilterSectionLayout from '../../components/CustomFilterSectionLayout/CustomFilterSectionLayout';
import $ from 'jquery';
import Moment from 'moment';
import ThemeContext from "../../context/themeContext/ThemeContext";
class ViewEvent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorText: '',
			eventDate: '',
			AllData: [],
			class: [],
			section: [],
			session: [],
			classId: '',
			sessionId: '',
			AllEventData: [],
			monthlyStudentList: [],
			newMonthlyStudentList: [],
			adminData: [],
			filterCheck: false,
			status: '',
			msgSnack: '',
			backColor: '',
			year: '',
			month: '',
			modalData: null,
			enabled: false,
			id: null,
			select: [],
			isLoading: true,
			disablepage: false,
			disableBPage: true,
			currentPage: 1,
			todosPerPage: 10,
			pageCounter: 10,
			msg: '',
			errorMsg: '',
			increament: 1,
			sectionId: '',
			sections: [],
			session: [],
			sessionId: '',
			btnLoad: false,
			exist: false,
			checking: [],
			searchCheck: true,
			badRequest: false,
			errorText: '',
			date: null
		};
	}
	handleClickNextFrwd = () => {
		const { adminData, todosPerPage, count, currentPage } = this.state;
		let pageNumbers = [];
		for (
			let i = 1;
			i <= Math.ceil(adminData.length / this.state.todosPerPage);
			i++
		) {
			pageNumbers.push(i);
		}
		console.log('pagelength: ', pageNumbers.length);
		console.log('current page: ', currentPage);
		if (currentPage === pageNumbers.length) {
			this.setState({
				disablepage: true
			});
		} else {
			this.setState(prevState => ({
				currentPage: prevState.currentPage + 1,
				disableBPage: false
			}));
		}
	};
	handleClickNextBack = () => {
		const { adminData, todosPerPage, count, currentPage } = this.state;
		console.log('current page: ', currentPage);
		if (currentPage === 1) {
			this.setState({
				disableBPage: true,
				disablepage: false
			});
		} else {
			this.setState(prevState => ({
				currentPage: prevState.currentPage - 1
			}));
			this.setState({
				disablepage: false
			});
		}
	};
	handleClickNext = event => {
		this.setState({
			currentPage: Number(event.target.id),
			disablepage: false,
			disableBPage: false
		});
	};

	componentDidUpdate() {
		$('.tooltip').tooltip('hide');

		if (
			this.state.msg ||
			this.state.errorMsg ||
			this.state.exist ||
			this.state.badRequest
		) {
			setTimeout(() => {
				this.setState({
					msg: false,
					errorMsg: false,
					exist: false,
					badRequest: false
				});
			}, 3000);
		}
	}

	componentDidMount() {
		$(document).ready(function() {
			$('[data-toggle="tooltip"]').tooltip();
		});

		this.props.sharedActions
			.getDataWithoutDispatch(
				'/api/GetConlidatedEventList/?pageNumber=1&pageSize=10&classId=&sessionId=&date=&month='
			)
			.then(success => {
				debugger;
				this.setState({
					AllEventData: success.classEvents,
					checking: success.paginationMetadata,
					searchCheck: false
				});
			})
			.catch(err => {
				this.setState({});

				console.log(err);
			});

		this.props.sharedActions
			.getDataWithoutDispatch('/api/ClassSection')
			.then(success => {
				debugger;
				this.setState({
					AllData: success,
					class: success.classList,
					isLoading: false
				});
			})
			.catch(err => {
				this.setState({});
				console.log(err);
			});
		this.props.sharedActions
			.getDataWithoutDispatch('/api/Session')
			.then(success => {
				debugger;
				this.setState({
					session: success.session,
					isLoading: false
				});
			})
			.catch(err => {
				this.setState({});
				console.log(err);
			});
	}

	btnTechHover = () => {
		$(document).ready(function() {
			$('button').hover(
				function() {
					$(this).css('box-shadow', '0px 5px 5px grey');
					$(this).css('border-color', 'white');
				},
				function() {
					$(this).css('box-shadow', '0px 0px 0px white');
				}
			);
		});
	};
	onTakeItemDelete = itemId => {
		this.setState({
			modalData: []
		});
		this.props.sharedActions
			.deleteRecordWithoutDispatchWithoutSlash('/api/Event/', itemId)
			.then(success => {
				debugger;
				let deleteData = this.state.AllEventData.filter(
					item => item.id != itemId
				);
				this.setState({
					AllEventData: deleteData,
					msg: 'Record Deleted Successfully!'
				});
				this.props.snackbar();
			})
			.catch(error => {
				debugger;
			});
	};
	onTakeItem = itemId => {
		this.setState({
			modalData: []
		});
		const { AllEventData } = this.state;
		let getData = AllEventData.filter(item => item.id === itemId);

		this.setState({
			modalData: getData,
			// status: getData[0].status,
			id: getData[0].id
		});
	};

	onHandleText = e => {
		console.log(e.target.value);
		this.setState({
			[e.target.name]: e.target.value
		});
		debugger;
	};

	onStatusChange = e => {
		console.log(e.target.value);
		this.setState(
			{
				status: e.target.value
			},
			this.hitFilterApi
		);
	};
	onHandleSubmit = e => {
		e.preventDefault();
		const { status, id } = this.state;
		var bodyParameters = {
			status
		};
		this.props.sharedActions
			.patchParticularRecord(`/api/ApproveVoucher/?id=${id}`, bodyParameters)
			.then(success => {
				debugger;
				this.setState({ enabled: false, msg: 'Edit Record Successfully!' });
				this.props.snackbar();
			})
			.catch(err => {
				this.setState({
					errorMsg: true,
					errorText: err.response.data.Message
				});
				debugger;
			});
	};
	onEditClick = itemId => {
		this.onTakeItem(itemId);
		this.setState({ enabled: false });
	};

	hitFilterApi = e => {
		let Date;
		if (this.state.date !== null) {
			debugger;
			Date = Moment(this.state.date).format('MM/DD/YYYY');
		} else {
			debugger;
			Date = '';
		}
		this.setState({
			searchCheck: true
		});
		this.props.sharedActions
			.getDataWithoutDispatch(
				`/api/GetConlidatedEventList?pageNumber=1&pageSize=10&classId=${this.state.classId}&sessionId=${this.state.sessionId}&month=${this.state.month}&date=${Date}`
			)
			.then(success => {
				debugger;
				this.setState({
					AllEventData: success.classEvents,
					checking: success.paginationMetadata,
					searchCheck: false
				});
			})
			.catch(err => {
				this.setState({
					isLoading: false
				});
				console.log(err);
			});
	};

	sessionChange = e => {
		this.setState(
			{
				sessionId: e.target.value
			},
			this.hitFilterApi
		);
	};

	onMonthChange = e => {
		this.setState(
			{
				month: e.target.value
			},
			this.hitFilterApi
		);
	};

	paginationRequest = number => {
		this.setState({
			searchCheck: true
		});
		console.log(number);
		let Date;
		if (this.state.date !== null) {
			debugger;
			Date = Moment(this.state.date).format('MM/DD/YYYY');
		} else {
			debugger;
			Date = '';
		}
		this.props.sharedActions
			.getDataWithoutDispatch(
				`/api/GetConlidatedEventList?pageNumber=${number}&pageSize=10&classId=${this.state.classId}&sessionId=${this.state.sessionId}&month=${this.state.month}&date=${Date}`
			)
			.then(success => {
				this.setState({
					AllEventData: success.classEvents,
					checking: success.paginationMetadata,
					searchCheck: false
				});
			})
			.catch(err => {
				this.setState({
					isLoading: false
				});

				console.log(err);
			});
	};

	onClassChange = e => {
		const Sections = this.state.AllData.section.filter(
			item => item.classId == e.target.value
		);
		this.setState(
			{
				section: Sections,
				classId: e.target.value
			},
			this.hitFilterApi
		);
	};
	onSectionChange = e => {
		this.setState(
			{
				sectionId: e.target.value
			},
			this.hitFilterApi
		);
	};
	changeDate = (date, state) => {
		debugger;
		this.setState(
			{
				[state]: date
			},
			this.hitFilterApi
		);
		console.log(date);
	};

	PrintContent = (el) => {
		var restorepage = document.body.innerHTML;
		var Printcontent = document.getElementById(el).innerHTML;
		document.body.innerHTML = Printcontent;
		window.print();
		document.body.innerHTML = restorepage;
		window.location.reload();
	  };

	render() {
		const { modalData } = this.state;
		const { session } = this.state.session;

		const Loader = (
			<ThemeContext.Consumer>
			{(context) => (
			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<div class="spinner-border" style={{ color: context.themeColors.primaryColor }}></div>
			</div>
			                  )}
							  </ThemeContext.Consumer>
		);

		let pageNumbers = [];
		for (
			let i = 1;
			i <=
			Math.ceil(this.state.checking.totalCount / this.state.checking.pageSize);
			i++
		) {
			pageNumbers.push(i);
		}

		const renderPageNumbers = pageNumbers.map((number, index) => {
			return (
				<ThemeContext.Consumer>
				{(context) => (
				<li
					class={`page-item ${
						this.state.checking.currentPage === number ? 'active' : ''
					} `}
				>
					<a
						key={number}
						id={number}
						onClick={() => this.paginationRequest(number)}
						class="page-link "
						href="#"
						style={{
							backgroundColor:context.themeColors.primaryColor,
							borderColor:context.themeColors.primaryColor
						}}
					>
						{number}
					</a>
				</li>
				                  )}
								  </ThemeContext.Consumer>
			);
		});

		const renderBillData = this.state.AllEventData.map((item, index) => {
			return (
				<ThemeContext.Consumer>
				{(context) => (
				<tr key={index}>
					<th scope="row">{index + 1}</th>
					<td>{item.month}</td>
					<td>{item.eventDate}</td>
					<td>{item.eventTime}</td>
					<td>{item.session}</td>
					<td>
						{item.classes.map((items, index) => (
							<label>{items.className},</label>
						))}
					</td>
					<td>{item.subject}</td>
					<td>{item.accountId}</td>
					<td>{item.accountType}</td>
					<td>{item.description}</td>
				</tr>
				                  )}
								  </ThemeContext.Consumer>
			);
		});

		const MainContent = (
			<ThemeContext.Consumer>
          {(context) => (
								<div id="div1">
								<div class="modal" id="myModal1">
					<div class="modal-dialog">
						<div class="modal-content modal_content_custom">
							<div
								style={{
									borderBottomLeftRadius: 30,
									borderBottomRightRadius: 30,
									borderTopLeftRadius: 18,
									borderTopRightRadius: 18
								}}
								class="modal-header modal_custom_header"
							>
								<h4 style={{ color: 'white' }} class="modal-title">
									Confirm
								</h4>
								<button
									style={{ color: 'white' }}
									type="button"
									class="close"
									data-dismiss="modal"
								>
									&times;
								</button>
							</div>
							<div class="modal-body">
								{modalData &&
									modalData.map((item, index) => (
										<div key={index}>
											<div style={{ textAlign: 'center' }}>
												<h4>Are you sure ?</h4>
											</div>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-evenly'
												}}
											>
												<div>
													<button
														disabled={this.state.enabled}
														data-dismiss="modal"
														onClick={() => this.onTakeItemDelete(this.state.id)}
														type="button"
														class="btn btn-primary buttonAppear"
													>
														Yes
													</button>
												</div>
												<div>
													<button
														data-dismiss="modal"
														disabled={this.state.enabled}
														type="button"
														class="btn btn-primary buttonAppear"
													>
														No
													</button>
												</div>
											</div>
										</div>
									))}
							</div>
						</div>
					</div>
				</div>
				<div class="modal" id="myModal">
					<div class="modal-dialog">
						<div class="modal-content modal_content_custom">
							<div
								style={{
									borderBottomLeftRadius: 30,
									borderBottomRightRadius: 30,
									borderTopLeftRadius: 18,
									borderTopRightRadius: 18
								}}
								class="modal-header modal_custom_header"
							>
								<h4 style={{ color: 'white' }} class="modal-title">
									Details
								</h4>
								<button
									style={{ color: 'white' }}
									type="button"
									class="close"
									data-dismiss="modal"
								>
									&times;
								</button>
							</div>
							<div class="modal-body">
								{this.state.errorMsg ? (
									<p style={{ color: 'red', textAlign: 'center' }}>
										{this.state.errorText}
									</p>
								) : (
									''
								)}
								<form onSubmit={this.onHandleSubmit}>
									{modalData &&
										modalData.map((item, index) => (
											<div key={index}>
												<fieldset disabled={!this.state.enabled}>
													<div class="form-group">
														<label for="campusName">Status:</label>
														<input
															style={{
																borderTop: 0,
																borderLeft: 0,
																borderRight: 0,
																boxShadow: 'none'
															}}
															type="text"
															value={this.state.status}
															onChange={this.onHandleText}
															readOnly={true}
															name="campusName"
															class="form-control"
															id="campusName"
														/>
													</div>
													<div class="form-group">
														<label for="campusName">Change Status:</label>
														<div class="col-md-12" style={{ marginTop: 20 }}>
															<div class="md-form mb-0">
																<select
																	onChange={this.onHandleText}
																	class="custom-select"
																	name="status"
																>
																	<option value="">Status</option>
																	<option value="Approve">Approve</option>
																	<option value="Not Paid">Not Paid</option>
																</select>
															</div>
														</div>
													</div>
												</fieldset>
												<button
													disabled={this.state.enabled}
													onClick={() => this.setState({ enabled: true })}
													type="button"
													class="btn btn-primary buttonAppear"
												>
													Edit
												</button>
												<button
													style={{ marginLeft: 5 }}
													disabled={!this.state.enabled}
													type="submit"
													class="btn btn-primary buttonAppear"
												>
													Save
												</button>
											</div>
										))}
								</form>
							</div>
							<div class="modal-footer">
								<button
									type="button"
									style={{ background: '#00435D' }}
									class="btn btn-danger"
									data-dismiss="modal"
								>
									Close
								</button>
							</div>
						</div>
					</div>
				</div>
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span className="customBadge" style={{ fontSize: 14 }}>
						Page: {this.state.checking.currentPage}
					</span>

					<span className="customBadge" style={{ fontSize: 14 }}>
						Total Page: {this.state.checking.totalPages}
					</span>
				</div>
				<div class="">
          <img
            src={require("../../Assets/images/header.png")}
            style={{
              width: "100%",
              height: "150",
            }}
          />
        </div>
				<table
					class="table table-hover table-bordered"
					style={{ textAlign: 'center' }}
				>
					<thead style={{ background: context.themeColors.primaryColor, color: 'white' }}>
						<tr>
							<th scope="col">#</th>
							<th scope="col">Month</th>
							<th scope="col">Date</th>
							<th scope="col">Time</th>
							<th scope="col">Session</th>
							<th scope="col">Grades</th>
							<th scope="col">Subject/Event</th>
							<th scope="col">Coordinator</th>
							<th scope="col">Account</th>
							<th scope="col">Description</th>
						</tr>
					</thead>
					<tbody>{renderBillData}</tbody>
				</table>
				<div class="page-footer">
            <div class="text-left">Printed By: {this.props.users.role}</div>
            <div class="text-right" style={{ marginTop: -25, marginRight: 20 }}>
              Powered by School Smart®
            </div>
		  </div>
			</div>
			                  )}
							  </ThemeContext.Consumer>
		);
		return (
			<ThemeContext.Consumer>
			{(context) => (
			<div>
				<SnackBar msg={this.state.msg} backColor={this.state.backColor} />

				{this.state.exist ? (
					<p style={{ color: 'red', textAlign: 'center' }}>
						Please Fill the Fields
					</p>
				) : (
					''
				)}
				{this.state.badRequest ? (
					<p style={{ color: 'red', textAlign: 'center' }}>
						{this.state.errorText}
					</p>
				) : (
					''
				)}
				<div className="page-header">
					<div class="row">
						<div class="col-md-3"></div>
						<div class="col-md-6">
							<h4 class="generalHead" style={{background: context.themeColors.primaryColor}}>Class Events</h4>
						</div>
						<div class="col-md-3 text-right">
							<nav aria-label="Page navigation example">
								<ul style={{ color: context.themeColors.primaryColor }} class="pagination">
									{renderPageNumbers}
								</ul>
							</nav>
						</div>
					</div>
				</div>
				<br />
				<div class="container no-print">
					<CustomFilterSectionLayout displayDirection="column">
						<div class="row" style={{ justifyContent: 'center' }}>
							<div class="col-md-3" style={{ marginTop: 20 }}>
								<div class="md-form mb-0">
									<label for="name" class="font-weight-bold">
										Grades
									</label>
									<select
										onChange={this.onClassChange}
										class="custom-select text-dark"
										name="classId"
									>
										<option
											value=""
											class=""
											selected={this.state.msg ? true : false}
										>
											Select All Grades
										</option>
										{this.state.class &&
											this.state.class.map((item, index) => (
												<option key={index} value={`${item.id}`}>
													{item.className}
												</option>
											))}
									</select>
								</div>
							</div>

							<div class="col-md-3" style={{ marginTop: 20 }}>
								<div class="md-form mb-0">
									<label for="name" class="font-weight-bold">
										Session
									</label>
									<select
										onChange={this.sessionChange}
										class="custom-select text-dark"
										name="month"
									>
										<option value="" selected={this.state.msg ? true : false}>
											Select All Session.
										</option>
										{this.state.session.map((item, index) => (
											<option key={index} value={`${item.sessionId}`}>
												{item.currentSession}
											</option>
										))}
									</select>
								</div>
							</div>
							<div class="col-md-3" style={{ marginTop: 20 }}>
								<div class="md-form mb-0">
									<label for="name" class="font-weight-bold">
										Month
									</label>
									<select
										onChange={this.onMonthChange}
										class="custom-select text-dark"
										name="month"
									>
										<option value="" selected={this.state.msg ? true : false}>
											Select All Months.
										</option>
										{months.Months.map((item, index) => (
											<option key={index} value={`${item}`}>
												{item}
											</option>
										))}
									</select>
								</div>
							</div>
							<div class="col-md-3" style={{ marginTop: 20 }}>
								<div class="md-form mb-0">
									<label for="name" class="font-weight-bold">
										Date
									</label>
									<br />
									<DatePicker
										onChange={e => this.changeDate(e, 'date')}
										value={this.state.date}
									/>
								</div>
							</div>
						</div>
					</CustomFilterSectionLayout>
				</div>
				<br />
				<br />
				{this.state.searchCheck ? Loader : MainContent}
				
				<div
          class="text-center text-md-right displayElemet"
          style={{ marginBottom: 10 }}
        >
          <label for="name" class="" onClick={() => this.PrintContent("div1")}>
            <i
              className="fas fa-print fa-2x animated fadeIn"
              style={{ marginRight: 4 }}
            />
            Print
          </label>
        </div>
			</div>
			                  )}
							  </ThemeContext.Consumer>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		sharedActions: bindActionCreators(sharedActions, dispatch)
	};
}
function mapStateToProps(state) {
	return {
		allTransportState: state.setStudentSkillReducer,
		users: state.setUserReducer.users
	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ViewEvent);
